export const rejectedAnswers: string[] = [
	'lyrics',
	'reddit',
	'tiktok',
	'youtube',
	'quote',
	'quotes',
	'meme',
	'memes',
	'quiz',
	'quotes',
	'a',
	'an',
	'the',
	'of',
	'is',
	'for',
	'an',
	'my',
	'of',
	'so',
	'the',
	'too',
	'a',
	'pdf',
	'in space',
	'in spanish',
	'2020',
	'2021',
	'2022',
	'2023',
	'2024',
];
